module.exports = __webpack_public_path__ + "static/img/wave.38e18b88.png";